import ChargePointListTable from "components/charging/ChargePointList/ChargePointListTable";
import UserContext from "Context/UserProvider";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Box, CircularProgress, Typography, Grid } from '@mui/material';
import { useApiService } from "../../services/ApiService/ApiService";

function isNull(array: any) {
    if (array === null || array === undefined) {
        return [];
    }
    return array;
}

function LocationChargePointsListPage(props: any) {
    const navigate = useNavigate();
    const { userInfo } = useContext(UserContext);
    const { fetchWithAuth } = useApiService();
    const [loading, setLoading] = useState(true);
    const [chargePoints, setChargePoints] = useState([]) as any;
    const [showCategory, setShowCategory] = useState([true, false, false, false]);
    const [activeMenu, setActiveMenu] = useState("All");
    const location = useLocation() as any;
    const dwellingUuid = location.state.dwellingUuid;


    function checking_null_undefined(array: any) {
        if (array === null || array === undefined) {
            return [];
        }
        return array;
    }


    async function fetchChargePoints() {
        setLoading(true);
        let bodyData: { [name: string]: string } = {};
        bodyData["uuid"] = userInfo.uuid;
        bodyData["fleetUuid"] = userInfo.fleetUuid;

        try {
            const response = await fetchWithAuth('/infrastructure/charge-point/list', {
                method: 'POST',
                body: JSON.stringify(bodyData),
            });

            if (!response.ok) {
                throw new Error('Failed to fetch charge points');
            }

            const res_json = await response.json();
            setChargePoints(res_json.chargePoints);
        } catch (error) {
            console.error('Error fetching charge points:', error);
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        console.log("DWE " + dwellingUuid);
        fetchChargePoints();
    }, []);

    if (loading) return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
            <CircularProgress />
        </Box>
    );
    return (

        <>
            {chargePoints.map((chargePoint: any, index: any) => (
                <ChargePointListTable key={index} chargePointData={chargePoint} />
                // <ChargePointListTable2 dwellingUuid={dwellingUuid} selectedChargers={chargePoints}></ChargePointListTable2>
            ))}
        </>


    );
}

export default LocationChargePointsListPage;
